let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f0bAg")).then(() => parcelRequire('7drfK'));